import Tasks from 'APP/Tasks';
import { IMessage } from 'APP/model/message/messageModel.types';
import { Group } from 'STORE/Groups/Group';

import { loadMessagesAboveTheTime } from '../loadMessagesAboveTheTime/loadMessagesAboveTheTime';

function checkIsMissedMessages(group: Group, previousMessageTs: number): boolean {
  return group.messagesStore?.getMessageByTs(previousMessageTs)?.serverTime !== previousMessageTs;
}

export async function addMessagesToStore(
  group: Group,
  messages: IMessage[],
  previousMessageTs: number
): Promise<void> {
  const messagesWithoutEditQueue = messages.filter((message) => {
    return !group.messagesStore.getMessageById(message.clientUuid)?.isEditQueue;
  });

  if (!previousMessageTs) {
    Tasks.messaging.updateOldOrFakeMessages({
      messages: messagesWithoutEditQueue,
      groupId: group.id,
    });
    return;
  }

  const isMissedMessages = checkIsMissedMessages(group, previousMessageTs);

  if (isMissedMessages) {
    const lastMessage = messages[messages.length - 1];
    await loadMessagesAboveTheTime(group.id, Number(lastMessage.serverTime), false);
    return;
  }

  Tasks.messaging.updateOldOrFakeMessages({
    messages: messagesWithoutEditQueue,
    groupId: group.id,
    prevMessageTs: Number(previousMessageTs),
  });
}
